/* vl-landing — behavior for vl-lx-* landing sections.
   Ported from the approved landing design; variant/qty/cart wired to
   real product data via data attributes instead of hardcoded ids. */
(function () {
  'use strict';
  if (window.vlLandingBound) return;
  window.vlLandingBound = true;

  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };

  /* gallery thumbs */
  document.addEventListener('click', function (e) {
    var t = e.target.closest('.vl-lx .gthumb');
    if (!t) return;
    var gallery = t.closest('.gallery');
    $$('.gthumb', gallery).forEach(function (x) { x.classList.remove('active'); });
    t.classList.add('active');
    var main = $('.gmain img', gallery);
    if (main && t.getAttribute('data-val')) main.src = t.getAttribute('data-val');
  });

  /* qty steppers */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('.vl-lx [data-qty-step]');
    if (!b) return;
    var input = $('input', b.closest('.qty'));
    var v = Math.max(1, (parseInt(input.value, 10) || 1) + parseInt(b.getAttribute('data-qty-step'), 10));
    input.value = v;
  });

  /* add to cart / buy now — [data-vlx-add] with data-variant, optional data-buynow */
  var busy = false;
  function currentQty() {
    var i = $('.vl-lx .qty input');
    return (i && parseInt(i.value, 10)) || 1;
  }
  function showToast() {
    var t = $('.vl-lx-toast');
    if (!t) return;
    t.classList.add('show');
    setTimeout(function () { t.classList.remove('show'); }, 2400);
  }
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-vlx-add]');
    if (!btn || busy) return;
    var variant = btn.getAttribute('data-variant');
    if (!variant) return;
    var q = currentQty();
    if (btn.hasAttribute('data-buynow')) {
      window.location.href = '/cart/' + variant + ':' + q;
      return;
    }
    busy = true;
    /* 2026-10-16: the "Ürün başarıyla sepetinize eklendi" pop-up (assets/vl-added.js) instead of the toast; the toast stays
       as the fallback when the pop-up is switched off */
    var va = window.vlAdded || null;
    var gimg = $('.vl-lx .gmain img');
    var meta = { opener: btn, variant: parseInt(variant, 10), image: gimg ? (gimg.currentSrc || gimg.src) : '' };
    if (va) va.begin(meta);
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: parseInt(variant, 10), quantity: q }] })
    })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }, function () { if (!r.ok) throw 0; return {}; }); })
      .then(function (resp) {
        busy = false;
        if (va) va.done(resp, meta); else showToast();
        fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) {
          $$('hdt-cart-count, .cart-count, .cart-count-bubble span, [data-cart-count]').forEach(function (el) { el.textContent = c.item_count; });
          document.dispatchEvent(new CustomEvent('cart:count:update', { detail: { item_count: c.item_count } }));
        }).catch(function () {});
        document.dispatchEvent(new CustomEvent('cart:reload'));
      })
      .catch(function (err) {
        busy = false;
        if (va) { va.fail(err && (err.description || err.message) ? err : ''); return; }
        window.location.href = '/cart/add?id=' + variant + '&quantity=' + q;
      });
  });

  /* Havale/EFT button (snippets/vl-havale-cta, context product): hand the
     landing's variant + qty to vl-havale.js, which switches the cart and goes
     to checkout. vl-havale.js ignores product-context clicks itself. */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.vl-lx [data-vl-havale][data-vl-havale-context="product"]');
    if (!btn || !window.vlHavale) return;
    var src = $('.vl-lx [data-vlx-add][data-variant]');
    var variant = src && parseInt(src.getAttribute('data-variant'), 10);
    if (!variant) return;
    window.vlHavale.buy(variant, currentQty(), btn.getAttribute('data-vl-havale-attr') || 'havale', btn.getAttribute('data-vl-havale-code') || '');
  });

  /* countdown — [data-vlx-countdown="hours"] with .seg h/m/s children.
     Stores the deadline rather than the seconds left, so browsing on to another
     page carries on where it was instead of restarting. Same key as the product
     pages, so one campaign clock follows the shopper around the store. */
  $$('[data-vlx-countdown]').forEach(function (box) {
    var segs = $$('.seg', box);
    if (segs.length < 3) return;
    var hours = parseFloat(box.getAttribute('data-vlx-countdown')) || 2;
    var span = Math.round(hours * 3600) * 1000;
    var key = 'vlCampaignEnds_' + hours;
    var memo = null;
    var read = function () {
      try { return parseInt(localStorage.getItem(key), 10); } catch (e) { return memo; }
    };
    var write = function (v) {
      memo = v;
      try { localStorage.setItem(key, String(v)); } catch (e) {}
    };
    var deadline = function () {
      var now = Date.now();
      var end = read();
      if (!end || isNaN(end) || end <= now || end > now + span) {
        end = now + span;
        write(end);
      }
      return end;
    };
    var end = deadline();
    var pad = function (n) { return ('0' + n).slice(-2); };
    var tick = function () {
      var t = Math.floor((end - Date.now()) / 1000);
      if (t < 0) { end = deadline(); t = Math.floor((end - Date.now()) / 1000); }
      segs[0].textContent = pad(Math.floor(t / 3600));
      segs[1].textContent = pad(Math.floor((t % 3600) / 60));
      segs[2].textContent = pad(t % 60);
    };
    tick();
    setInterval(tick, 1000);
    document.addEventListener('visibilitychange', function () {
      if (!document.hidden) { end = deadline(); tick(); }
    });
  });

  /* sticky bar — shows when the price box scrolls out of view */
  var sticky = $('.vl-lx-stickybar');
  var buyBox = $('.vl-lx .pricebox');
  if (sticky && buyBox) {
    window.addEventListener('scroll', function () {
      var r = buyBox.getBoundingClientRect();
      if (r.bottom < 0) sticky.classList.add('show');
      else sticky.classList.remove('show');
    }, { passive: true });
  }

  /* reveal on scroll */
  var els = $$('.vl-lx .rv');
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('in'); io.unobserve(en.target); }
      });
    }, { threshold: 0.12 });
    els.forEach(function (el, i) { el.style.transitionDelay = (i % 4 * 60) + 'ms'; io.observe(el); });
  } else {
    els.forEach(function (el) { el.classList.add('in'); });
  }
})();
